import { useQuery } from '@tanstack/react-query'
import { Endpoints, fakeApi } from './api'
import rootStore from '../store/RootStore'

export const fetchOptionsByFilter = async data => {
  const filters = JSON.parse(JSON.stringify(data.queryKey[1]))
  const params = {}
  Object.entries(filters).forEach(
    filter => (params[filter[0]] = filter[1].value),
  )
  return fakeApi.post(Endpoints.Options, params)
}

const useFetchOptionsByFilter = async () => {
  const filters = Object.fromEntries(
    rootStore.reportStore.filterOptionsSelected,
  )

  return useQuery([Endpoints.Options, filters], fetchOptionsByFilter, {
    onSuccess: result => {
      if (result.data.length) {
        rootStore.optionsTableStore.setOptionsTable(result.data)
      }
    },
    onError: err => console.error(err),
  })
}

export default useFetchOptionsByFilter
